import { Paginator as Paginators } from 'primereact/paginator';  

const Paginator = ({...rest}) => {

    return (
        <Paginators {...rest} />
    )

};

export default Paginator;